import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import './index.scss';

export interface IModalProps {
  title?: string;
  subtitle?: string;
  active?: boolean;
  onClose?: () => void;
  forForm?: boolean;
  hideClose?: boolean;
  children: React.ReactNode;
  wideView?: boolean;
  className?: string;
}

const Modal: React.FC<IModalProps> = props => {
  const [activeToggle, setActiveToggle] = useState(false);
  const { title, subtitle, active, onClose, forForm, hideClose, wideView, className } = props;

  useEffect(() => {
    setActiveToggle(active || false);
  }, [active]);

  return (
    <div className={classnames('bix_modal', className, { active: activeToggle })}>
      <div className={classnames(wideView ? 'modal_box_wide' : 'modal_box', { for_form: !!forForm }, 'wideView')}>
        <h3 className="modal_title">{title}</h3>
        {subtitle && <h4 className="modal_subtitle">{subtitle}</h4>}
        {!hideClose && <div className="closeBtn" onClick={onClose} />}
        {props.children}
      </div>
    </div>
  );
};

export default Modal;
